export const NEXT_BILLING_DATE = (t) => t('next-billing-date-on');
export const SUBSCRIPTION_END_DATE = (t) => t('subscription-ends-on');
export const SUBSCRIPTION_WILL_END = (t) => t('subscription-will-end-in');
